import React from 'react';

const Footer = () => {
    return (
        <footer class="bg-gray-800 text-white py-8">
            <div class="container mx-auto px-4">
                <div class="flex flex-col md:flex-row justify-between items-center">
                    <div class="mb-6 md:mb-0">
                        <div class="flex items-center space-x-2">
                            <img
                                src="/logo_nb.png" // Reference the logo from the public folder
                                alt="StockEasy Logo"
                                class="h-10" // Adjust the height as needed
                            />
                            <span class="text-xl font-bold">StockEasy</span>
                        </div>
                        <p class="mt-2 text-gray-400">
                            Innovative inventory solutions for car parts businesses.
                        </p>
                    </div>
                    <div class="flex space-x-6">
                        <a href="#" class="text-gray-400 hover:text-white transition">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="#" class="text-gray-400 hover:text-white transition">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="#" class="text-gray-400 hover:text-white transition">
                            <i class="fab fa-linkedin-in"></i>
                        </a>
                        <a href="#" class="text-gray-400 hover:text-white transition">
                            <i class="fab fa-instagram"></i>
                        </a>
                    </div>
                </div>
                <div class="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
                    <p>&copy; 2025 StockEasy. All rights reserved.</p>
                    <p>{process.env.REACT_APP_VERSION}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;